<script setup lang="ts">
import { computed, storeToRefs } from '#imports';
import { vOnClickOutside } from '@vueuse/components';

import { useUserAuthStore } from './../store/auth';

import IconCrossBold from '@/assets/icons/icon-cross-bold.svg';

const props = defineProps<{
	modelValue: boolean;
}>();

const emit = defineEmits<{
	(e: 'update:modelValue', val: boolean): void;
}>();

const isOpen = computed({
	get: () => props.modelValue,
	set: (value: boolean) => emit('update:modelValue', value),
});

const handleClosePopup = () => emit('update:modelValue', false);

const userAuthStore = useUserAuthStore();
const { user } = storeToRefs(userAuthStore);
const { logout } = userAuthStore;
</script>

<template>
	<div
		v-if="isOpen"
		v-on-click-outside="handleClosePopup"
		class="popup-user-profile"
	>
		<button
			class="popup-user-profile__close button"
			@click="isOpen = false"
		>
			<icon-cross-bold class="icon icon--default" />
		</button>

		<div class="popup-user-profile__inner">
			<div v-if="user === null" class="popup-user-profile__data">
				Информации о пользователе пока что нет.
			</div>
			<div v-else class="popup-user-profile__data">
				{{ user?.email }}
			</div>

			<ul class="popup-user-profile__actions">
				<li class="popup-user-profile__actions-item">
					<v-button class="w-full" @click="[handleClosePopup(), logout()]">
						Выйти
					</v-button>
				</li>
			</ul>
		</div>
	</div>
</template>

<style lang="scss">
.popup-user-profile {
	width: rem(320px);
	padding: rem($gap) rem($gap-medium) rem($gap-medium);

	border-radius: rem($radius-secondary);
	background-color: $white;
	box-shadow: $shadow-dialog;

	&__close {
		position: absolute;
		top: rem($gap-mini);
		right: rem($gap-mini);

		color: $black;
	}

	&__data {
		@include text-base(700);

		word-break: break-word;
	}

	&__actions {
		margin-top: rem($gap-medium);

		&-item {
			margin-bottom: rem($gap-mini);

			@include reset-indent-last;
		}
	}
}
</style>
